module.exports = {
	"author": "pal",
	"permlink": "2scmtp-test",
	"category": "test",
	"parent_author": "",
	"parent_permlink": "test",
	"title": "test",
	"body": "test",
	"allow_replies": true,
	"allow_votes": true,
	"allow_curation_rewards": true,
	"url": "/test/@pal/2scmtp-test"
};


//////////////////
// WEBPACK FOOTER
// ./test/test-post.json
// module id = 342
// module chunks = 1